import { useHasUserTag, push } from '@centra/centra-ui'
import { isMobile } from 'react-device-detect'
import { useLocation } from 'react-router-dom'

export const useRedirectToTaskTracker = () => {
  const query = new URLSearchParams(useLocation().search)
  const currentTaskId = query.get('task')
  const isEmployee = useHasUserTag('employeeUser')

  if (isMobile) {
    window.location.href = (window.location.origin +
      `/tasktracker/task${currentTaskId ? `/${currentTaskId}` : ''}`) as string

    return false
  }
  if (isEmployee) {
    return true
  }

  /** Это просто от некорректных ссылок */
  if (location.href.includes('?task=')) {
    const taskId = location.search.replace('?task=', '')
    push(`${location.origin}/task/${taskId}`)
    return false
  }

  if (['/task', '/cabinet'].some(p => location.href.includes(p))) {
    return true
  }

  push(`${location.origin}/tasktracker/task`)
  return false
}
